import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-724eaa34"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  autoplay: "",
  loop: "",
  muted: "",
  controls: false,
  style: {"width":"100vw","height":"100vh","z-index":"-100","position":"absolute","top":"0","left":"0"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "screen-4k grid grid-nogutter" }
const _hoisted_4 = { class: "col-12 flex justify-content-center align-content-between" }
const _hoisted_5 = { class: "text-white p-0 my-auto mr-auto ml-4" }
const _hoisted_6 = { class: "screen-title text-white" }
const _hoisted_7 = { class: "text-white p-0 my-auto ml-auto mr-4" }
const _hoisted_8 = { class: "col-3" }
const _hoisted_9 = { class: "col-3" }
const _hoisted_10 = { class: "col-3" }
const _hoisted_11 = { class: "col-3" }
const _hoisted_12 = { class: "col-3" }
const _hoisted_13 = { class: "col-3" }
const _hoisted_14 = { class: "col-3" }
const _hoisted_15 = { class: "col-3" }
const _hoisted_16 = { class: "col-3" }
const _hoisted_17 = { class: "col-9" }

import { computed, onMounted, onUnmounted, ref } from "vue";
import { useDisplay } from "./composables/useDisplay";
import RdGameBoard from "../components/RdGameBoard.vue";
import AnguilaGameBoard from "../components/AnguilaGameBoard.vue";
import env from "@/env.json";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const secondsToRefreshInfo = 5 * 60;
const defaultSecondsToChangeScreen = 5 * 60;


export default /*#__PURE__*/_defineComponent({
  __name: 'DisplayRD',
  setup(__props) {

const intervals: any[] = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const timeouts: any[] = [];
const loading = ref(true);
const url = `${env.API_URL}/rd`;
const videoSrc = ref(`${env.API_URL}/video`);

const { wakelock, currents, date, isToday, dteRef, dteComputed, changeOnRef, changeOnComputed, updateCurrent, getInfo } = useDisplay(url);

const setChangeScreen = () => {
  changeOnRef.value = currents.value?.seconds ?? defaultSecondsToChangeScreen;

  timeouts.push(
    setTimeout(() => {
      changeOnRef.value = 0;

      timeouts.pop();

      updateCurrent();

      setChangeScreen();
    }, (currents.value?.seconds ?? defaultSecondsToChangeScreen) * 1000),
  );
};

onMounted(async () => {
  await getInfo();

  loading.value = false;

  intervals.push(setInterval(getInfo, secondsToRefreshInfo * 1000));
  intervals.push(setInterval(() => (dteRef.value = new Date()), 500));
  intervals.push(
    setInterval(() => {
      changeOnRef.value -= 1;
      if (changeOnRef.value < 0) {
        changeOnRef.value = 0;
      }
    }, 1000),
  );

  setChangeScreen();
});

onUnmounted(() => {
  for (const interval of intervals) {
    clearInterval(interval);
  }

  for (const timeout of timeouts) {
    clearTimeout(timeout);
  }

  wakelock.value?.release();
});

const lottery18 = computed(() => currents.value?.results.find((current) => current.id === 18));
const lottery19 = computed(() => currents.value?.results.find((current) => current.id === 19));
const lottery20 = computed(() => currents.value?.results.find((current) => current.id === 20));
const lottery21 = computed(() => currents.value?.results.find((current) => current.id === 21));
const lottery22 = computed(() => currents.value?.results.find((current) => current.id === 22));
const lottery23 = computed(() => currents.value?.results.find((current) => current.id === 23));
const lottery24 = computed(() => currents.value?.results.find((current) => current.id === 24));
const lottery25 = computed(() => currents.value?.results.find((current) => current.id === 25));
const lottery26 = computed(() => currents.value?.results.find((current) => current.id === 26));
const lottery27 = computed(() => currents.value?.results.find((current) => current.id === 27));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("video", _hoisted_1, [
      _createElementVNode("source", {
        src: videoSrc.value,
        type: "video/mp4"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(changeOnComputed)), 1),
        _createElementVNode("h1", _hoisted_6, [
          _createTextVNode(_toDisplayString(_unref(isToday) ? "TODAY'" : "YESTERDAY'") + " " + _toDisplayString(_unref(date)) + " ", 1),
          _createElementVNode("i", {
            class: _normalizeClass(["pi pi-circle-fill", { 'text-green-500': _unref(isToday), 'text-red-500': !_unref(isToday) }])
          }, null, 2)
        ]),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(dteComputed)), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(RdGameBoard, {
          info: lottery18.value,
          isToday: _unref(isToday)
        }, null, 8, ["info", "isToday"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(RdGameBoard, {
          info: lottery19.value,
          isToday: _unref(isToday)
        }, null, 8, ["info", "isToday"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(RdGameBoard, {
          info: lottery20.value,
          isToday: _unref(isToday)
        }, null, 8, ["info", "isToday"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(RdGameBoard, {
          info: lottery21.value,
          isToday: _unref(isToday)
        }, null, 8, ["info", "isToday"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(RdGameBoard, {
          info: lottery22.value,
          isToday: _unref(isToday)
        }, null, 8, ["info", "isToday"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(RdGameBoard, {
          info: lottery23.value,
          isToday: _unref(isToday)
        }, null, 8, ["info", "isToday"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(RdGameBoard, {
          info: lottery24.value,
          isToday: _unref(isToday)
        }, null, 8, ["info", "isToday"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(RdGameBoard, {
          info: lottery25.value,
          isToday: _unref(isToday)
        }, null, 8, ["info", "isToday"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(RdGameBoard, {
          info: lottery26.value,
          isToday: _unref(isToday)
        }, null, 8, ["info", "isToday"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(AnguilaGameBoard, {
          info: lottery27.value,
          isToday: _unref(isToday)
        }, null, 8, ["info", "isToday"])
      ])
    ])
  ], 64))
}
}

})